import {Component, Inject} from '@angular/core';
import {Image, ImageSize} from '../model/image';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {TourApiService} from '../services/tour-api.service';
import {EnumAware} from '../decorators/enum-aware.decorator';
@EnumAware
@Component({
  selector: 'gt-image-dialog',
  template:
      `<div class="imageWrapper" (click)="dialog.close()"
         [ngStyle]="{ 'background-image': apiService.backgroundImageStyle(image, ImageSize.Large) }">
    </div>`,
  styles: [`
    .imageWrapper {
      width: 100%;
      height: 100%;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-color: #000;
      padding: 0;
    }
  `]
})
export class ImageDialogComponent {

  ImageSize = ImageSize;
  image: Image;
  dialog: MatDialogRef<any>;
  constructor(public dialogRef: MatDialogRef<any>,
              public apiService: TourApiService,
              @Inject(MAT_DIALOG_DATA) private data: any) {
    this.dialog = dialogRef;
    this.image = data;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/image-dialog.component.ts